/* Tiloli — Index marques : filtre live (recherche) + scroll-spy A→Z (lettre active en magenta). */
(function () {
  function init() {
    var section = document.querySelector('.tlbi');
    if (!section) return;
    var input = section.querySelector('[data-tlbi-search]');
    var groups = Array.prototype.slice.call(section.querySelectorAll('.tlbi__group'));
    var azLinks = Array.prototype.slice.call(section.querySelectorAll('.tlbi__az-link'));

    // --- Filtre live ---
    function filter() {
      var q = (input && input.value || '').trim().toLowerCase();
      groups.forEach(function (g) {
        var anyVisible = false;
        Array.prototype.forEach.call(g.querySelectorAll('.tlbi__card'), function (c) {
          var match = !q || (c.dataset.name || '').indexOf(q) !== -1;
          c.hidden = !match;
          if (match) anyVisible = true;
        });
        g.hidden = !anyVisible;
      });
      azLinks.forEach(function (a) {
        var g = document.getElementById('tlbi-' + a.dataset.letter);
        a.style.display = g && g.hidden ? 'none' : '';
      });
    }
    if (input) input.addEventListener('input', filter);

    // --- Scroll-spy : lettre active ---
    if ('IntersectionObserver' in window && groups.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var L = e.target.getAttribute('data-letter');
          azLinks.forEach(function (a) { a.classList.toggle('is-active', a.dataset.letter === L); });
        });
      }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });
      groups.forEach(function (g) { io.observe(g); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
